import PostSection1 from "./PostSection1.vue";
import PostSection2 from "./PostSection2.vue";
import PostSection3 from "./PostSection3.vue";
import PostSection4 from "./PostSection4.vue";
import PostSection5 from "./PostSection5.vue";
import PostSection6 from "./PostSection6.vue";
export default {
  name: "PostSections",
  components: {
    PostSection1: PostSection1,
    PostSection2: PostSection2,
    PostSection3: PostSection3,
    PostSection4: PostSection4,
    PostSection5: PostSection5,
    PostSection6: PostSection6
  },
  props: {
    postSections: {
      type: Array,
      required: true
    }
  },
  methods: {
    getComponentName: function getComponentName(type) {
      var typeMap = {
        postSection1: "PostSection1",
        postSection2: "PostSection2",
        postSection3: "PostSection3",
        postSection4: "PostSection4",
        postSection5: "PostSection5",
        postSection6: "PostSection6"
      };
      return typeMap[type];
    }
  }
};